<template>
  <div v-if="video" class="tw-max-w-[300px] tw-mb-4 tw-border tw-border-gray-200 tw-rounded-lg tw-p-3 tw-shadow-sm">
    <div class="tw-cursor-pointer" @click="handleClick">
      <img :src="video.preview_path" :alt="video.title" class="tw-w-full tw-rounded-md tw-mb-2">
    </div>
    <a class="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-cursor-pointer" @click="handleClick">
      {{ video.title }}
    </a>
  </div>
  <Dialog v-model:open="showVideoModal">
    <DialogContent>
      <DialogHeader>
        <DialogTitle v-if="video">{{ video.title }}</DialogTitle>
      </DialogHeader>
      <div v-if="showVideoModal">
        <VideoIframe :url="router('web.video.embed', {canonical: video.canonical})" :size="videoSize" />
      </div>
      <DialogFooter>
        <DialogClose as-child>
          <button type="button" class="btn btn-default">Close</button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/shadcn/components/ui/dialog/index.js'
import VideoIframe from '../common/video-iframe.vue'

export default {
  name: 'QuickConversationVideoPreview',
  components: {
    Dialog,
    DialogClose,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    VideoIframe
  },
  props: {
    canonical: {
      type: String,
      required: true
    }
  },
  setup (props, { emit }) {
    const video = ref(null)
    const showVideoModal = ref(false)
    const videoSize = ref('16-9')

    const fetchVideo = () => {
      axios.get(Spark.router('api.video.show-by-canonical', { canonical: props.canonical }))
        .then(response => {
          video.value = response.data.video

          if (video.value.video_resolution) {
            const ratio = video.value.video_resolution.height / video.value.video_resolution.width

            if (ratio <= 9 / 16) {
              videoSize.value = '16-9'
            } else if (ratio <= 2 / 3) {
              videoSize.value = '3-2'
            } else if (ratio <= 3 / 4) {
              videoSize.value = '4-3'
            } else {
              videoSize.value = '1-1'
            }
          }
        })
    }

    const handleClick = () => {
      showVideoModal.value = true
    }

    onMounted(() => {
      fetchVideo()
    })

    return {
      video,
      videoSize,
      showVideoModal,
      handleClick
    }
  }
}
</script>
